module.exports = __webpack_public_path__ + "static/media/estate-clarity-activity-userflow.80ff8cdc.jpg";